import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'

export default {
    /**
     * Reports JS errors to Bugsnag if we have an api key set
     */
    bugsnag() {
        if (typeof bugsnagApiKey === "string") {
            window.bugsnag = Bugsnag.start({
                apiKey: bugsnagApiKey,
                plugins: [new BugsnagPluginVue()],
            })
        }
    }
}
